import { useCallback } from 'react';

import { CommonActions, useNavigation, useRoute } from '@react-navigation/native';

// pops the calling screen, not the focused route - plain goBack pops whatever was pushed above us
export const usePopSelf = () => {
    const navigation = useNavigation();
    const { key: routeKey } = useRoute();

    return useCallback(() => {
        navigation.dispatch(state => ({ ...CommonActions.goBack(), source: routeKey, target: state.key }));
    }, [navigation, routeKey]);
};
